module.exports = __webpack_public_path__ + "static/media/18ECA35.da18624a.jpg";